import React from 'react';

// Delete confirmation modal (ManageDoctor)
const ConfirmationModal = ({
  title,
  message,
  successButtonName,
  closeModal,
  modalData,
  successAction,
}) => {
  return (
    <div>
      <input type='checkbox' id='confirmation-modal' className='modal-toggle' />
      <div className='modal'>
        <div className='modal-box'>
          <h3 className='font-bold text-lg'>{title}</h3>
          <p className='py-4'>{message}</p>
          <div className='modal-action'>
            <label
              onClick={() => successAction(modalData)}
              htmlFor='confirmation-modal'
              className='btn btn-primary'
            >
              {successButtonName}
            </label>
            <button onClick={closeModal} className='btn btn-outline'>
              cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
// 76-7, 8 